(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-element"] && !Shopify.designMode) return;
  try {
    if (!window.TomeCarouselElement) {
    class TomeCarouselElement extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.perPage = 1;
        this.step = 1;
        this.perPageMediaQuery = null;
        this.scrollTrack = null;
        this._scrollRaf = 0;
        this.dotClickHandlers = [];
        this.dotKeyHandlers = [];
        this.itemClickHandlers = [];
        this.prevButton = null;
        this.nextButton = null;
        this.counter = null;
        this.descriptionTargets = null;
        this._autoplayTimer = null;
        this._autoplayPaused = false;
        this._autoplayInView = false;
        this._autoplayObserver = null;
        this.handleHostClick = this.handleHostClick.bind(this);
        this.handleCarouselKeydown = this.handleCarouselKeydown.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onScrollSnapScroll = this.onScrollSnapScroll.bind(this);
        this.handleAutoplayMouseEnter = this.handleAutoplayMouseEnter.bind(this);
        this.handleAutoplayMouseLeave = this.handleAutoplayMouseLeave.bind(this);
        this.handleAutoplayFocusIn = this.handleAutoplayFocusIn.bind(this);
        this.handleAutoplayFocusOut = this.handleAutoplayFocusOut.bind(this);
      }

      get slideCount() {
        let maxIndex = -1;
        this.slides.forEach((slide) => {
          const index = parseInt(slide.dataset.slide, 10);
          if (!Number.isNaN(index) && index > maxIndex) {
            maxIndex = index;
          }
        });
        return maxIndex + 1;
      }

      get slides() {
        return this.querySelectorAll('[data-slide]');
      }

      get maxIndex() {
        return Math.max(0, this.slideCount - this.perPage);
      }

      getSlidesAt(index) {
        return this.querySelectorAll(`[data-slide="${index}"]`);
      }

      hasScrollSnap() {
        return this.hasAttribute('data-scroll-snap');
      }

      hasResponsivePerPage() {
        return (
          this.dataset.perPageMobile !== undefined
          && this.dataset.perPageDesktop !== undefined
        );
      }

      readPerPage() {
        if (this.hasResponsivePerPage()) {
          const mobile = parseInt(this.dataset.perPageMobile, 10);
          const desktop = parseInt(this.dataset.perPageDesktop, 10);
          const breakpoint = parseInt(this.dataset.breakpoint || '760', 10);
          const query = `(min-width: ${breakpoint}px)`;

          if (!this.perPageMediaQuery || this.perPageMediaQuery.media !== query) {
            this.teardownResponsivePerPage();
            this.perPageMediaQuery = window.matchMedia(query);
            this.perPageMediaQuery.addEventListener('change', this.onBreakpointChange);
          }

          const value = this.perPageMediaQuery.matches ? desktop : mobile;
          return Number.isNaN(value) || value < 1 ? 1 : value;
        }

        const staticPerPage = parseInt(this.dataset.perPage || '1', 10);
        return Number.isNaN(staticPerPage) || staticPerPage < 1 ? 1 : staticPerPage;
      }

      readStep() {
        const step = parseInt(this.dataset.step, 10);
        if (!Number.isNaN(step) && step > 0) {
          return step;
        }
        return this.perPage;
      }

      pageStartForIndex(index) {
        return Math.floor(index / this.perPage) * this.perPage;
      }

      setupResponsivePerPage() {
        if (!this.hasResponsivePerPage()) {
          return;
        }
        this.readPerPage();
      }

      teardownResponsivePerPage() {
        if (this.perPageMediaQuery) {
          this.perPageMediaQuery.removeEventListener('change', this.onBreakpointChange);
          this.perPageMediaQuery = null;
        }
      }

      setupScrollSnap() {
        this.scrollTrack = this.querySelector('[data-carousel-track]');
        if (!this.scrollTrack || this.slides.length === 0) {
          return;
        }

        this.scrollTrack.addEventListener('scroll', this.onScrollSnapScroll, { passive: true });
        this.syncActiveFromScroll();
      }

      teardownScrollSnap() {
        if (this.scrollTrack) {
          this.scrollTrack.removeEventListener('scroll', this.onScrollSnapScroll);
          this.scrollTrack = null;
        }

        if (this._scrollRaf) {
          cancelAnimationFrame(this._scrollRaf);
          this._scrollRaf = 0;
        }
      }

      onScrollSnapScroll() {
        if (this._scrollRaf) {
          return;
        }

        this._scrollRaf = requestAnimationFrame(() => {
          this._scrollRaf = 0;
          this.syncActiveFromScroll();
        });
      }

      getIndexFromScroll() {
        if (!this.scrollTrack) {
          return null;
        }

        const scrollLeft = this.scrollTrack.scrollLeft;
        let anchorIndex = 0;
        let minDistance = Infinity;

        this.slides.forEach((slide) => {
          const index = parseInt(slide.dataset.slide, 10);
          if (Number.isNaN(index)) {
            return;
          }

          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            anchorIndex = index;
          }
        });

        return Math.min(anchorIndex, this.maxIndex);
      }

      syncActiveFromScroll() {
        const index = this.getIndexFromScroll();
        if (index === null || index === this.currentIndex) {
          return;
        }

        this.setActiveState(index, { force: true });
      }

      scrollToIndex(index) {
        const slide = this.getSlidesAt(index)[0];
        if (!slide || !this.scrollTrack) {
          return;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const trackRect = this.scrollTrack.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const offset = slideRect.left - trackRect.left + this.scrollTrack.scrollLeft;

        this.scrollTrack.scrollTo({
          left: offset,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      onBreakpointChange() {
        const nextPerPage = this.readPerPage();
        if (nextPerPage === this.perPage) {
          return;
        }

        this.perPage = nextPerPage;
        this.step = this.readStep();
        const clampedIndex = Math.min(this.currentIndex, this.maxIndex);
        this.goTo(clampedIndex, { force: true });
      }

      shouldAutoplay() {
        return (
          this.dataset.autoplay === 'true'
          && this.slideCount > 1
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        );
      }

      startAutoplay() {
        if (!this.shouldAutoplay() || this._autoplayPaused || !this._autoplayInView) {
          return;
        }

        this.stopAutoplay();
        const speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this._autoplayTimer = setInterval(() => this.advanceAutoplay(), speed);
      }

      stopAutoplay() {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }

      advanceAutoplay() {
        const nextIndex = this.currentIndex >= this.maxIndex ? 0 : this.currentIndex + this.step;
        this.goTo(nextIndex);
      }

      resetAutoplay() {
        this.startAutoplay();
      }

      setupAutoplay() {
        if (!this.shouldAutoplay()) {
          return;
        }

        this.addEventListener('mouseenter', this.handleAutoplayMouseEnter);
        this.addEventListener('mouseleave', this.handleAutoplayMouseLeave);
        this.addEventListener('focusin', this.handleAutoplayFocusIn);
        this.addEventListener('focusout', this.handleAutoplayFocusOut);

        this._autoplayObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) {
              return;
            }

            this._autoplayInView = entry.isIntersecting;

            if (this._autoplayInView) {
              this.startAutoplay();
              return;
            }

            this.stopAutoplay();
          },
          { threshold: 0 },
        );
        this._autoplayObserver.observe(this);
      }

      teardownAutoplay() {
        this.stopAutoplay();

        if (this._autoplayObserver) {
          this._autoplayObserver.disconnect();
          this._autoplayObserver = null;
        }

        this._autoplayInView = false;
        this.removeEventListener('mouseenter', this.handleAutoplayMouseEnter);
        this.removeEventListener('mouseleave', this.handleAutoplayMouseLeave);
        this.removeEventListener('focusin', this.handleAutoplayFocusIn);
        this.removeEventListener('focusout', this.handleAutoplayFocusOut);
      }

      handleAutoplayMouseEnter() {
        this._autoplayPaused = true;
        this.stopAutoplay();
      }

      handleAutoplayMouseLeave() {
        this._autoplayPaused = false;
        this.startAutoplay();
      }

      handleAutoplayFocusIn() {
        this._autoplayPaused = true;
        this.stopAutoplay();
      }

      handleAutoplayFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this._autoplayPaused = false;
          this.startAutoplay();
        }
      }

      connectedCallback() {
        this.setupResponsivePerPage();
        this.perPage = this.readPerPage();
        this.step = this.readStep();
        this.dots = this.querySelectorAll('[data-dot]');
        this.items = this.querySelectorAll('[data-index]');
        this.animatedTitle = this.querySelector('character-fade-text:not([data-fade-field])');
        this.descriptionTargets = this.querySelectorAll('[data-description-target]');
        const activeSlide = this.querySelector('[data-slide].is-active');
        this.currentIndex = activeSlide ? parseInt(activeSlide.dataset.slide, 10) : 0;
        if (Number.isNaN(this.currentIndex) || this.currentIndex < 0) {
          this.currentIndex = 0;
        }

        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = this.maxIndex;
        }

        this.setActiveState(this.currentIndex, { force: true });

        this.addEventListener('click', this.handleHostClick);
        this.addEventListener('keydown', this.handleCarouselKeydown);

        this.dots.forEach((dot) => {
          const onClick = () => {
            const dotIndex = parseInt(dot.dataset.dot, 10);
            this.goTo(this.pageStartForIndex(dotIndex));
            this.resetAutoplay();
          };
          const onKeydown = (event) => this.handleDotKeydown(event, dot);
          dot.addEventListener('click', onClick);
          dot.addEventListener('keydown', onKeydown);
          this.dotClickHandlers.push([dot, onClick]);
          this.dotKeyHandlers.push([dot, onKeydown]);
        });

        this.items.forEach((item) => {
          const onClick = () => {
            this.goTo(parseInt(item.dataset.index, 10));
            this.resetAutoplay();
          };
          item.addEventListener('click', onClick);
          this.itemClickHandlers.push([item, onClick]);
        });

        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-counter]');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.handlePrevClick);
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.handleNextClick);
        }

        if (this.hasScrollSnap()) {
          this.setupScrollSnap();
        }

        this.updateNavState();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        this.teardownAutoplay();
        this.teardownResponsivePerPage();
        this.teardownScrollSnap();
        this.removeEventListener('click', this.handleHostClick);
        this.removeEventListener('keydown', this.handleCarouselKeydown);

        this.dotClickHandlers.forEach(([dot, handler]) => dot.removeEventListener('click', handler));
        this.dotKeyHandlers.forEach(([dot, handler]) => dot.removeEventListener('keydown', handler));
        this.itemClickHandlers.forEach(([item, handler]) => item.removeEventListener('click', handler));

        this.dotClickHandlers = [];
        this.dotKeyHandlers = [];
        this.itemClickHandlers = [];

        if (this.prevButton) {
          this.prevButton.removeEventListener('click', this.handlePrevClick);
        }
        if (this.nextButton) {
          this.nextButton.removeEventListener('click', this.handleNextClick);
        }
      }

      handleHostClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }

        const dot = target.closest('[data-dot]');
        if (dot && this.contains(dot)) {
          const dotIndex = parseInt(dot.dataset.dot, 10);
          this.goTo(this.pageStartForIndex(dotIndex));
          this.resetAutoplay();
          return;
        }

        const item = target.closest('[data-index]');
        if (item && this.contains(item)) {
          this.goTo(parseInt(item.dataset.index, 10));
          this.resetAutoplay();
        }
      }

      handleCarouselKeydown(event) {
        const target = event.target;
        if (
          target instanceof HTMLElement
          && (
            target.tagName === 'INPUT'
            || target.tagName === 'TEXTAREA'
            || target.tagName === 'SELECT'
            || target.isContentEditable
            || target.closest('[data-dot]')
          )
        ) {
          return;
        }

        const nextIndex = this.resolveNextIndex(this.currentIndex, event.key);
        if (nextIndex === null) {
          return;
        }

        event.preventDefault();
        this.goTo(nextIndex);
        this.dots[nextIndex]?.focus();
        this.resetAutoplay();
      }

      handleDotKeydown(event, dot) {
        const currentDotIndex = parseInt(dot.dataset.dot, 10);

        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          this.goTo(this.pageStartForIndex(currentDotIndex));
          this.resetAutoplay();
          return;
        }

        const currentPageStart = this.pageStartForIndex(currentDotIndex);
        const nextIndex = this.resolveNextIndex(currentPageStart, event.key);

        if (nextIndex === null) {
          return;
        }

        event.preventDefault();
        this.goTo(nextIndex);
        this.dots[nextIndex]?.focus();
        this.resetAutoplay();
      }

      handlePrevClick() {
        this.goTo(this.currentIndex - this.step);
        this.resetAutoplay();
      }

      handleNextClick() {
        this.goTo(this.currentIndex + this.step);
        this.resetAutoplay();
      }

      getTextSourceSlide() {
        const slides = this.getSlidesAt(this.currentIndex);
        return (
          Array.from(slides).find((slide) => slide.dataset.title !== undefined)
          || slides[0]
        );
      }

      updateAnimatedText() {
        const textSource = this.getTextSourceSlide();
        if (!textSource) {
          return;
        }

        this.querySelectorAll('character-fade-text[data-fade-field]').forEach((element) => {
          const field = element.dataset.fadeField;
          const text = textSource.dataset[field] ?? '';
          const textNode = document.createElement('span');
          textNode.textContent = text;
          element.replaceChildren(textNode);
        });

        if (this.animatedTitle) {
          const text = textSource.dataset.title ?? '';
          const textNode = document.createElement('span');
          textNode.textContent = text;
          this.animatedTitle.replaceChildren(textNode);

          // Apply the active slide's typography preset to the animated title, if set.
          const textStyle = textSource.dataset.textStyle;
          if (textStyle) {
            const typeClasses = [
              'type-body',
              'type-h1',
              'type-h2',
              'type-h3',
              'type-quote',
              'type-section-header',
            ];
            this.animatedTitle.classList.remove(...typeClasses);
            this.animatedTitle.classList.add(textStyle);
          }
        }

        // Description is not animated, so it may contain HTML (<p>, <strong>, <br>, ...).
        // The attribute is decoded back to real tags by dataset; innerHTML parses it.
        if (this.descriptionTargets) {
          this.descriptionTargets.forEach((element) => {
            element.innerHTML = textSource.dataset.description ?? '';
          });
        }
      }

      updateNavState() {
        if (this.prevButton) {
          const atStart = this.currentIndex === 0;
          this.prevButton.disabled = atStart;
          this.prevButton.setAttribute('aria-disabled', String(atStart));
        }
        if (this.nextButton) {
          const atEnd = this.currentIndex >= this.maxIndex;
          this.nextButton.disabled = atEnd;
          this.nextButton.setAttribute('aria-disabled', String(atEnd));
        }
        if (this.counter) {
          this.counter.textContent = `${this.currentIndex + 1} / ${this.slideCount}`;
        }
      }

      resolveNextIndex(currentIndex, key) {
        let nextIndex = null;

        if (key === 'ArrowRight' || key === 'ArrowDown') {
          nextIndex = currentIndex + this.step;
        }

        if (key === 'ArrowLeft' || key === 'ArrowUp') {
          nextIndex = currentIndex - this.step;
        }

        if (nextIndex === null || nextIndex < 0 || nextIndex > this.maxIndex) {
          return null;
        }

        return nextIndex;
      }

      setActiveState(index, options = {}) {
        const force = options.force === true;

        if (!force && index === this.currentIndex) {
          return false;
        }

        if (index < 0 || index > this.maxIndex) {
          return false;
        }

        const newActiveIndices = new Set();
        for (let i = index; i < index + this.perPage; i++) {
          newActiveIndices.add(i);
        }

        if (!this.hasScrollSnap()) {
          for (let i = 0; i < this.slideCount; i++) {
            if (newActiveIndices.has(i)) continue;

            this.getSlidesAt(i).forEach((slide) => {
              if (!slide.classList.contains('is-active')) {
                return;
              }

              slide.classList.remove('is-active');
              slide.classList.add('is-leaving');

              let didCleanup = false;
              const cleanupLeavingState = () => {
                if (didCleanup) {
                  return;
                }
                didCleanup = true;
                slide.classList.remove('is-leaving');
                slide.removeEventListener('animationend', cleanupLeavingState);
              };

              slide.addEventListener('animationend', cleanupLeavingState);
              window.setTimeout(cleanupLeavingState, 600);
            });
          }
        }

        for (let i = 0; i < this.slideCount; i++) {
          const isActive = newActiveIndices.has(i);

          if (this.hasScrollSnap()) {
            this.getSlidesAt(i).forEach((slide) => {
              slide.classList.toggle('is-active', isActive);
            });
          }

          if (isActive) {
            this.dots[i]?.classList.add('is-active');
            this.dots[i]?.setAttribute('aria-selected', 'true');
            this.items[i]?.classList.add('is-active');
          } else {
            this.dots[i]?.classList.remove('is-active');
            this.dots[i]?.setAttribute('aria-selected', 'false');
            this.items[i]?.classList.remove('is-active');
          }
        }

        if (!this.hasScrollSnap()) {
          for (let i = index; i < index + this.perPage; i++) {
            this.getSlidesAt(i).forEach((slide) => slide.classList.add('is-active'));
          }
        }

        this.currentIndex = index;
        this.updateAnimatedText();

        this.updateNavState();
        return true;
      }

      goTo(index, options = {}) {
        const force = options.force === true;

        if (index < 0 || index > this.maxIndex) {
          return;
        }

        if (!force && index === this.currentIndex) {
          return;
        }

        if (this.hasScrollSnap()) {
          if (!options.skipScroll) {
            this.scrollToIndex(index);
          }
          this.setActiveState(index, { force: true });
          return;
        }

        if (!this.setActiveState(index, { force })) {
          return;
        }
      }
    }

    window.TomeCarouselElement = TomeCarouselElement;
  }

  if (!customElements.get('tome-carousel')) {
    customElements.define('tome-carousel', window.TomeCarouselElement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["character-fade-text"] && !Shopify.designMode) return;
  try {
    class CharacterFadeText extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.currentText = '';
      this.transitionTimer = null;
      this.heightTimer = null;
    }

    connectedCallback() {
      this.shadowRoot.innerHTML = /* html */`
        <style>
          :host {
            display: block;
            width: 100%;
          }

          .stage {
            position: relative;
            display: block;
            width: 100%;
            min-height: 1lh;
            transition: height var(--height-transition-duration, var(--transition-duration)) var(--transition-easing);
          }

          .layer {
            display: block;
            width: 100%;
            white-space: pre-wrap;
          }

          .layer--measure {
            visibility: hidden;
            position: relative;
          }

          .layer--current {
            position: relative;
          }

          .layer--overlay {
            position: absolute;
            inset: 0;
          }

          .char {
            display: inline-block;
            opacity: 0;
          }

          @media (prefers-reduced-motion: no-preference) {
            .char {
              transition: opacity var(--transition-duration) var(--transition-easing);
              transition-delay: calc(var(--char-index) * var(--char-step, 10ms) + var(--transition-duration) * 0.2);
            }

            .layer--out .char {
              transition-delay: calc(var(--char-index) * var(--char-step, 10ms));
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .stage {
              transition: none;
            }

            .char {
              opacity: 1 !important;
            }
          }

          .word {
            display: inline-block;
            white-space: nowrap;
          }

          .layer--current .char,
          .layer--in .char {
            opacity: 1;
          }

          .layer--out .char {
            opacity: 0;
          }

          slot {
            display: none;
          }
        </style>
        <div class="stage"></div>
        <slot></slot>
      `;

      this.stage = this.shadowRoot.querySelector('.stage');
      this.slotElement = this.shadowRoot.querySelector('slot');
      this.slotElement.addEventListener('slotchange', () => this.onSlotChange());
      this.onSlotChange();
    }

    disconnectedCallback() {
      if (this.transitionTimer) {
        clearTimeout(this.transitionTimer);
      }

      if (this.heightTimer) {
        clearTimeout(this.heightTimer);
      }
    }

    getTransitionDuration(textA, textB) {
      const longestLength = Math.max(textA.length, textB.length, 1);
      return longestLength * 24 + 360;
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    setStageHeight(height, options = {}) {
      const { immediate = false, duration = null } = options;

      if (this.heightTimer) {
        clearTimeout(this.heightTimer);
        this.heightTimer = null;
      }

      if (duration !== null) {
        this.stage.style.setProperty('--height-transition-duration', `${duration}ms`);
      }

      if (this.prefersReducedMotion() || immediate) {
        this.stage.style.transition = 'none';
        this.stage.style.height = height === null ? '' : `${height}px`;

        if (height === null) {
          this.stage.style.removeProperty('--height-transition-duration');
        }

        requestAnimationFrame(() => {
          this.stage.style.transition = '';
        });
        return;
      }

      this.stage.style.height = height === null ? '' : `${height}px`;

      if (height === null) {
        this.stage.style.removeProperty('--height-transition-duration');
      }
    }

    onSlotChange() {
      const nextText = this.getSlottedText();

      if (this.transitionTimer) {
        clearTimeout(this.transitionTimer);
        this.transitionTimer = null;
      }

      if (this.heightTimer) {
        clearTimeout(this.heightTimer);
        this.heightTimer = null;
      }

      const currentLayer = this.getSourceLayer();

      if (!currentLayer) {
        const nextLayer = this.buildLayer(nextText);
        nextLayer.classList.add('layer--current');
        this.stage.replaceChildren(nextLayer);
        this.currentText = nextText;
        return;
      }

      this.normalizeToSingleCurrentLayer(currentLayer);
      this.currentText = currentLayer.dataset.text || '';

      if (nextText === this.currentText) {
        return;
      }

      const nextLayer = this.buildLayer(nextText);
      nextLayer.classList.add('layer--measure');
      this.stage.appendChild(nextLayer);

      const currentHeight = currentLayer.offsetHeight;
      const nextHeight = nextLayer.offsetHeight;
      const peakHeight = Math.max(currentHeight, nextHeight);
      const duration = this.getTransitionDuration(this.currentText, nextText);

      this.setStageHeight(currentHeight, { immediate: true });
      requestAnimationFrame(() => {
        this.setStageHeight(peakHeight, { duration });
      });

      currentLayer.classList.remove('layer--current');
      currentLayer.classList.add('layer--overlay', 'layer--out');

      nextLayer.classList.remove('layer--measure');
      nextLayer.classList.add('layer--overlay');
      requestAnimationFrame(() => {
        nextLayer.classList.add('layer--in');
      });

      this.transitionTimer = setTimeout(() => {
        currentLayer.remove();
        nextLayer.classList.remove('layer--overlay', 'layer--in');
        nextLayer.classList.add('layer--current');
        this.currentText = nextText;
        this.transitionTimer = null;

        if (nextHeight < peakHeight) {
          requestAnimationFrame(() => {
            this.setStageHeight(nextHeight, { duration });
            this.heightTimer = setTimeout(() => {
              this.setStageHeight(null);
              this.heightTimer = null;
            }, duration);
          });
          return;
        }

        this.setStageHeight(null);
      }, duration);
    }

    getSourceLayer() {
      const currentLayer = this.stage.querySelector('.layer--current');

      if (currentLayer) {
        return currentLayer;
      }

      const incomingLayer = this.stage.querySelector('.layer--in');

      if (incomingLayer) {
        return incomingLayer;
      }

      const allLayers = this.stage.querySelectorAll('.layer');

      if (allLayers.length === 0) {
        return null;
      }

      return allLayers[allLayers.length - 1];
    }

    normalizeToSingleCurrentLayer(sourceLayer) {
      const allLayers = this.stage.querySelectorAll('.layer');

      allLayers.forEach((layer) => {
        if (layer !== sourceLayer) {
          layer.remove();
        }
      });

      sourceLayer.classList.remove('layer--overlay', 'layer--out', 'layer--in', 'layer--measure');
      sourceLayer.classList.add('layer--current');
      this.setStageHeight(null, { immediate: true });
    }

    getSlottedText() {
      const nodes = this.slotElement.assignedNodes({ flatten: true });

      return nodes
        .map((node) => node.textContent || '')
        .join('')
        .replace(/\s+/g, ' ')
        .trim();
    }

    buildLayer(text) {
      const layer = document.createElement('span');
      layer.className = 'layer';
      layer.dataset.text = text;
      const value = text || ' ';
      const maxDuration = 500;
      const stepMs = Math.min(10, maxDuration / value.length);
      layer.style.setProperty('--char-step', `${stepMs}ms`);

      let charIndex = 0;
      const parts = value.split(/(\s+)/);

      parts.forEach((part) => {
        if (!part) {
          return;
        }

        if (/^\s+$/.test(part)) {
          layer.appendChild(document.createTextNode(part));
          return;
        }

        const word = document.createElement('span');
        word.className = 'word';

        [...part].forEach((character) => {
          const charElement = document.createElement('span');
          charElement.className = 'char';
          charElement.style.setProperty('--char-index', String(charIndex));
          charElement.textContent = character;
          word.appendChild(charElement);
          charIndex += 1;
        });

        layer.appendChild(word);
      });

      return layer;
    }
  }

  if (!customElements.get('character-fade-text')) {
    customElements.define('character-fade-text', CharacterFadeText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    function initLazyImages() {
    document.querySelectorAll('.image-element[loading="lazy"]').forEach((img) => {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyImages);
  } else {
    initLazyImages();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-abbreviator"] && !Shopify.designMode) return;
  try {
    (function () {
    function initAbbreviators(root) {
      root.querySelectorAll('.text-abbreviator:has(.text-abbreviator__abbr)').forEach(function (el) {
        var button = el.closest('a, button, .button');
        if (!button) return;

        var abbrSpan = el.querySelector('.text-abbreviator__abbr');

        function update() {
          // Reset to full label so we measure the worst case
          el.classList.remove('text-abbreviator--abbreviated');
          abbrSpan.setAttribute('aria-hidden', 'true');

          // Compare the text span's natural width against the button's inner
          // content area (clientWidth minus horizontal padding). Works for both
          // in-flow buttons (flex overflow: visible hides layout overflow) and
          // absolutely-positioned buttons (text overflows the box).
          var style = window.getComputedStyle(button);
          var innerWidth = button.clientWidth
            - parseFloat(style.paddingLeft)
            - parseFloat(style.paddingRight);

          if (el.scrollWidth > innerWidth + 1) {
            el.classList.add('text-abbreviator--abbreviated');
            abbrSpan.removeAttribute('aria-hidden');
          }
        }

        new ResizeObserver(update).observe(button.parentElement);
        update();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAbbreviators(document); });
    } else {
      initAbbreviators(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
